import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, Outlet } from 'react-router-dom'
import { PlayerContextProvider } from '@store/player'
import Nav from '@components/Nav'
import Player from '@components/Player'
import Footer from '@components/Footer'
import "./App.css";

function App() {
  const { pathname } = useLocation()

  if (!window.localStorage.getItem('USER_LIST')) {
    window.localStorage.setItem('USER_LIST', '[]')
  }

  return (
    <div id="app">
      <PlayerContextProvider>
        <div id="header">
          <Nav />
        </div>
        <div id="main">
            <Outlet/>
        </div>
        <div id="footer">
          <Footer />
        </div>
        <Player />
      </PlayerContextProvider>
    </div>
  )
}

export default App
